import { __assign, __read, __values } from "tslib";
import { breakpointList } from './breakpointList';
var matchCache = new Map();
var getMatchGroups = function (breakpoint) {
    var ltMatchGroup = [];
    var gtMatchGroup = [];
    if (breakpoint === null) {
        for (var i = 0; i < breakpointList.length; i++) {
            ltMatchGroup.push("lt-" + breakpointList[i]);
        }
    }
    else {
        var bpIndex = breakpointList.indexOf(breakpoint);
        for (var i = 0; i < bpIndex; i++) {
            gtMatchGroup.unshift("gt-" + breakpointList[i]);
        }
        for (var i = bpIndex + 1; i < breakpointList.length; i++) {
            ltMatchGroup.push("lt-" + breakpointList[i]);
        }
    }
    return { ltMatchGroup: ltMatchGroup, gtMatchGroup: gtMatchGroup };
};
var getMatchMap = function (_a, matchBP) {
    var e_1, _b, e_2, _c;
    var ltMatchGroup = _a.ltMatchGroup, gtMatchGroup = _a.gtMatchGroup;
    var matchMap = {};
    if (matchBP !== null)
        matchMap[matchBP] = true;
    try {
        for (var ltMatchGroup_1 = __values(ltMatchGroup), ltMatchGroup_1_1 = ltMatchGroup_1.next(); !ltMatchGroup_1_1.done; ltMatchGroup_1_1 = ltMatchGroup_1.next()) {
            var ltBP = ltMatchGroup_1_1.value;
            var _d = __read(ltBP.split('-'), 2), bp = _d[1];
            matchMap["lt" + bp.toUpperCase()] = true;
            matchMap[ltBP] = true;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (ltMatchGroup_1_1 && !ltMatchGroup_1_1.done && (_b = ltMatchGroup_1.return)) _b.call(ltMatchGroup_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    try {
        for (var gtMatchGroup_1 = __values(gtMatchGroup), gtMatchGroup_1_1 = gtMatchGroup_1.next(); !gtMatchGroup_1_1.done; gtMatchGroup_1_1 = gtMatchGroup_1.next()) {
            var gtBP = gtMatchGroup_1_1.value;
            var _e = __read(gtBP.split('-'), 2), bp = _e[1];
            matchMap["gt" + bp.toUpperCase()] = true;
            matchMap[gtBP] = true;
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (gtMatchGroup_1_1 && !gtMatchGroup_1_1.done && (_c = gtMatchGroup_1.return)) _c.call(gtMatchGroup_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return matchMap;
};
export var getMatchDetail = function (breakpoint) {
    if (!matchCache.has(breakpoint)) {
        var matchGroups = getMatchGroups(breakpoint);
        var matchMap = getMatchMap(matchGroups, breakpoint);
        matchCache.set(breakpoint, __assign(__assign({}, matchGroups), { matchBP: breakpoint, matchMap: matchMap }));
    }
    return matchCache.get(breakpoint);
};
